import { memo } from 'react'
import { cn } from '../../../../lib/utils'

interface ShimmerPlaceholderProps {
  width?: string | number
  height?: string | number
  className?: string
}

export const ShimmerPlaceholder = memo(function ShimmerPlaceholder({
  width = '100%',
  height = 16,
  className,
}: ShimmerPlaceholderProps) {
  return (
    <div
      className={cn('shimmer-placeholder', className)}
      style={{
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
      }}
    />
  )
})

ShimmerPlaceholder.displayName = 'ShimmerPlaceholder'
